import { useNavigate } from 'react-router-dom';
import { Searching } from '~components';
import * as Styled from './styled';

function CreationDenied() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
  };

  return (
    <Styled.Container data-testid="creation-denied-container">
      <Styled.IllustrationColumn>
        <Searching />
      </Styled.IllustrationColumn>
      <Styled.DetailsColumn>
        <Styled.Title>
          Infelizmente não podemos prosseguir com sua solicitação no momento.
        </Styled.Title>
        <Styled.Subtitle>
          Para mais informações entre em contato através dos nossos canais de
          atendimento:
        </Styled.Subtitle>
        <Styled.Footer>
          <Styled.ContactText variant="sub300" color="neutral-strong">
            SAC: (11) 0000 0000 <br />
            Ouvidoria: (11) 0800 000 000
          </Styled.ContactText>
          <Styled.Button onClick={handleClick}>Voltar ao início</Styled.Button>
        </Styled.Footer>
      </Styled.DetailsColumn>
    </Styled.Container>
  );
}

export default CreationDenied;
